<template>
    <div>
        <!-- When more than 1 layer, show layer selection-->
        <div v-if="layers.length > 1">
            <x-select
                id="LayerSelect"
                @changed="$_onLayerSelected($event)"
                :options="layers"
                v-model="layerId"
                :simpleMode="true"
                :showDefaultOption="false"
            >
            </x-select>
        </div>
        <div class="object-detail-paging">
            <!-- Button go to First feature -->
            <b-link
                class="icon_first full_rounded left"
                v-bind:class="{ bg_grey_darker: hasPrevious }"
                :disabled="!hasPrevious"
                @click="$_selectFeature(togglePagingConst.first)"
                >First</b-link
            >
            <!-- Button go to Next feature -->
            <b-link
                class="icon_back full_rounded back left"
                :disabled="!hasPrevious"
                v-bind:class="{ bg_grey_darker: hasPrevious }"
                @click="$_selectFeature(togglePagingConst.previous)"
                >Back</b-link
            >
            <!-- Feature Counter -->
            <span class="feature-counter"
                >{{ index + 1 - firstIndex }} van
                {{ lastIndex - firstIndex + 1 }}</span
            >
            <!-- Button go to Next feature -->
            <b-link
                class="icon_next full_rounded next right"
                v-bind:class="{ bg_grey_darker: hasNext }"
                :disabled="!hasNext"
                @click="$_selectFeature(togglePagingConst.next)"
                >Next</b-link
            >
            <!-- Button go to Last feature -->
            <b-link
                class="icon_last full_rounded right"
                v-bind:class="{ bg_grey_darker: hasNext }"
                :disabled="!hasNext"
                @click="$_selectFeature(togglePagingConst.last)"
                >Last</b-link
            >
        </div>
    </div>
</template>
<script>
    import { TOGGLE_PAGING } from '../constants';
    import { isSmallDevice } from '../services/utilities/devices';

    export default {
        data() {
            return {
                // Constants
                togglePagingConst: TOGGLE_PAGING,
                index: 0,
                firstIndex: 0,
                lastIndex: 0,
                isSmallDevice: isSmallDevice(),
                layers: [],
                layerId: 0
            };
        },

        props: {
            features: { type: Array, required: true },
            indexStart: { type: Number, required: true, default: 0 }
        },

        computed: {
            /**
             * Has next feature?
             * @returns  {boolean} indicates if next feature available
             */
            hasNext() {
                if (_.isNull(this.index)) {
                    return false;
                }
                return this.index < this.lastIndex;
            },

            /**
             * Has previous feature?
             * @returns  {boolean} indicates if previous feature available
             */
            hasPrevious() {
                if (_.isNull(this.index)) {
                    return false;
                }
                return this.index > this.firstIndex;
            }
        },

        methods: {
            /**
             * Select the next/previous/first/last feature if available
             * @param {object} togglePagingType the selection type (options in TOGGLE_PAGING)
             */
            $_selectFeature(togglePagingType) {
                switch (togglePagingType) {
                    // Set selected feature index
                    case TOGGLE_PAGING.next:
                        if (this.hasNext) {
                            this.index++;
                        }
                        break;

                    case TOGGLE_PAGING.previous:
                        if (this.hasPrevious) {
                            this.index--;
                        }
                        break;

                    case TOGGLE_PAGING.first:
                        if (this.hasPrevious) {
                            this.index = this.firstIndex;
                        }
                        break;

                    case TOGGLE_PAGING.last:
                        if (this.hasNext) {
                            this.index = this.lastIndex;
                        }
                        break;
                }
                this.$emit('indexChanged', this.index);
            },
            $_setFirstLastIndex() {
                this.firstIndex = this.features.findIndex(
                    (f) => f.layerId === this.layerId
                );
                this.lastIndex = this.features.findLastIndex(
                    (f) => f.layerId === this.layerId
                );
            },
            $_onLayerSelected(layerId) {
                // Set layerId to selected layer Id
                // set index to first item of this layer.
                this.layerId = layerId;
                this.index = this.features.findIndex(
                    (f) => f.layerId === this.layerId
                );
                this.$emit('indexChanged', this.index);
            }
        },

        watch: {
            indexStart: {
                handler: function (newVal) {
                    this.index = newVal;
                    this.layerId = this.features[newVal].layerId;
                    this.$_setFirstLastIndex();
                },
                immediate: true
            },
            features: {
                handler: function (newVal) {
                    // Extract list of unique layers from the incoming features list.
                    let id = 0;
                    this.layers = [];
                    for (const feature of this.features) {
                        if (feature.layerId != id && feature.layer) {
                            this.layers.push({
                                text: feature.layer.data.title,
                                value: feature.layerId
                            });
                            id = feature.layerId;
                        }
                    }
                    // recalculate lastindex
                    this.$_setFirstLastIndex();
                },
                immediate: true
            }
        }
    };
</script>

<style lang="scss" scoped>
.object-detail-paging {
    display: flex;
    justify-content: space-between;
    width: 240px;
    text-align: center;
    line-height: 30px;
    padding-bottom: 15px;
    a {
        width: 30px;
        height: 30px;
        background-color: #a2a2a2;
        color: #707070;
        background-size: 22px;
        cursor: pointer;
        text-indent: 999em;
        overflow: hidden;
        &.disabled {
            background-color: #d2d2d2;
            color: #707070;
        }
        &:first-child {
            margin-right: 5px;
        }
        &:last-child {
            margin-left: 5px;
        }
    }
}

.feature-counter {
    flex-grow: 1;
}

.full_rounded {
    border-radius: 50%;
}

.icon_next {
    background: url('~@/assets/icons/ic_fluent_chevron_right_20_filled_white.svg')
        no-repeat center center;
}

.icon_back {
    background: url('~@/assets/icons/ic_fluent_chevron_left_20_filled_white.svg')
        no-repeat center center;
}

.icon_first {
    background: url('~@/assets/icons/ic_fluent_arrow_previous_20_filled_white.svg')
        no-repeat center center;
}

.icon_last {
    background: url('~@/assets/icons/ic_fluent_arrow_next_20_filled_white.svg')
        no-repeat center center;
}
</style>
